// Use Czech alphabetic order for name lists, without changing sporting rank criteria.
private val tourNameCollator: dynamic = js("new Intl.Collator('cs', { usage: 'sort', sensitivity: 'accent' })")
internal val tourNameComparator: Comparator<String> = Comparator { first, second ->
    (tourNameCollator.compare(first, second) as Number).toInt()
}
